import * as types from './actionTypes'
import { bizNumbersService } from '../_services'

export function fetchBizNumbers() {
    return dispatch => {
        return bizNumbersService
            .getBizNumbers()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_BIZNUMBERS, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_BIZNUMBERS_FAILURE, error }
    }
}

export function updateBizNumber(data) {
    return function(dispatch) {
        return bizNumbersService
            .updateBizNumber(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_BIZNUMBER, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_BIZNUMBER_FAILURE, error }
    }
}

export function addBizNumber(data) {
    return function(dispatch) {
        return bizNumbersService
            .addBizNumber(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_BIZNUMBER, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_BIZNUMBER_FAILURE, error }
    }
}

export function removeBizNumberById(id) {
    return function(dispatch) {
        return bizNumbersService
            .removeBizNumberById(id)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.REMOVE_BIZNUMBER, payload: payload }
    }
    function failure(error) {
        return { type: types.REMOVE_BIZNUMBER_FAILURE, error }
    }
}
